import { render, staticRenderFns } from "./PastAlertsTable.vue?vue&type=template&id=1f9f8ab5"
import script from "./PastAlertsTable.vue?vue&type=script&lang=js"
export * from "./PastAlertsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports